import { motion } from 'framer-motion';

const Contact = () => {
  return (
    <section id="contact" className="section contact">
      <div className="section__inner contact__inner">
        <motion.p
          className="section__eyebrow"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          Contact
        </motion.p>

        <motion.h2
          className="contact__title"
          initial={{ opacity: 0, y: 36 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        >
          Let&apos;s build something worth shipping.
        </motion.h2>

        <motion.p
          className="contact__lead"
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.1 }}
        >
  Based in Majd Al-Kurum, Israel. Always open to collaborations, freelance, and full-time roles.
        </motion.p>

        <motion.div
          className="contact__links"
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.18 }}
        >
          <a className="contact__link" href="mailto:abrahem_horani@hotmail.com">
            <span className="contact__label">Email</span>
            <span className="contact__value">abrahem_horani@hotmail.com</span>
          </a>
          <a className="contact__link" href="tel:+972525743133">
            <span className="contact__label">Phone</span>
            <span className="contact__value">052-574-3133</span>
          </a>
          <a
            className="contact__link"
            href="https://github.com/IbrahemHurani"
            target="_blank"
            rel="noreferrer"
          >
            <span className="contact__label">GitHub</span>
            <span className="contact__value">@IbrahemHurani</span>
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default Contact;
